import React, { useState } from "react";

const PersonalInfo = ({ profileData }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!profileData) return null;

  return (
    <div className="personal-info-box" style={{ marginBottom: "5px" }}>
      {/* Header */}
      <h4
        className="title_roolt_checkout"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>
          <i
            className="bi bi-person-fill"
            style={{ fontSize: "20px",}}
          ></i>
          Personal Information
        </span>

        <i
          className={`bi ${
            isOpen ? "bi-chevron-up" : "bi-chevron-down"
          }`}
        ></i>
      </h4>

      {/* Dropdown Content */}
      {isOpen && (
        <div className="root_track">
          <div className="border0023">
            <div className="row trackrow mb-0">
              <div className="per-row-input">
                <span className="box-postiondefine">
                  <input
                    type="text"
                    value={`${profileData?.first_name || ""} ${
                      profileData?.last_name || ""
                    }`}
                    placeholder="Full Name"
                    className="input_checkout"
                    readOnly
                  />
                  <i className="bi bi-person"></i>
                </span>
              </div>
            </div>

            <div className="row">
              <div className="per-row-input">
                <span className="box-postiondefine">
                  <input
                    type="email"
                    value={profileData?.email || ""}
                    placeholder="Email"
                    className="input_checkout"
                    readOnly
                  />
                  <i className="bi bi-envelope"></i>
                </span>

                <span className="box-postiondefine">
                  <input
                    type="tel"
                    value={
                      profileData?.mobile
                        ? `+91 ${profileData.mobile}`
                        : ""
                    }
                    placeholder="Mobile"
                    className="input_checkout"
                    readOnly
                  />
                  <i className="bi bi-telephone"></i>
                </span>
              </div>
            </div>

            {/* <div className="row mt-3">
              <div className="per-row-input">
                <span className="box-postiondefine">
                  <input
                    type="text"
                    value={profileData?.address || ""}
                    placeholder="Address"
                    className="input_checkout"
                    readOnly
                  />
                  <i className="bi bi-geo-alt"></i>
                </span>
              </div>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalInfo;